import { gql } from '@apollo/client';

export const PERMISSIONS = gql`
  query Permissions {
    permissions {
      permission
      role
      type
    }
  }
`;

export const CURRENT_LOGGED_IN_USER_PERMISSIONS = gql`
  query CurrentLoggedInUserPermissions {
    currentLoggedInUserPermissions
  }
`;

export const ACCESS_TOKEN_FROM_ONE_TIME_TOKEN = gql`
  mutation TokenFromOneTimeToken($token: String!) {
    tokenFromOneTimeToken(token: $token) {
      accessToken
      expiresInSeconds
      refreshToken
    }
  }
`;

export const IMPERSONATION_ALLOWED = gql`
  query ImpersonationAllowed($id: Int!) {
    impersonationAllowed(id: $id) {
      allowed
    }
  }
`;

export const IMPERSONATION_USER_TOKEN = gql`
  mutation ImpersonationUserToken($id: Int!) {
    impersonationUserToken(id: $id) {
      token
    }
  }
`;
